import { createFileRoute } from '@tanstack/react-router';
import { SpecToolsSettingsPage } from '../components/settings/spec-tools-settings.js';

export const Route = createFileRoute('/$workspaceSlug/settings/spec-ai/tools')({
  component: SpecToolsSettingsPage,
});
